import { useUser } from "../helpers/userContext"

export const useAuth = () => {
  const { token } = useUser()
  return !!token
}
